

import __layout_0 from '/var/www/sites/stage.app.navodayatransport.com/releases/94/src/layouts/default.vue'
export const layouts = {
'blank': () => import('/var/www/sites/stage.app.navodayatransport.com/releases/94/src/layouts/blank.vue'),
'default': __layout_0,
'components/DefaultLayoutWithVerticalNav': () => import('/var/www/sites/stage.app.navodayatransport.com/releases/94/src/layouts/components/DefaultLayoutWithVerticalNav.vue'),
'components/Footer': () => import('/var/www/sites/stage.app.navodayatransport.com/releases/94/src/layouts/components/Footer.vue'),
'components/NavBarI18n': () => import('/var/www/sites/stage.app.navodayatransport.com/releases/94/src/layouts/components/NavBarI18n.vue'),
'components/NavBarNotifications': () => import('/var/www/sites/stage.app.navodayatransport.com/releases/94/src/layouts/components/NavBarNotifications.vue'),
'components/NavSearchBar': () => import('/var/www/sites/stage.app.navodayatransport.com/releases/94/src/layouts/components/NavSearchBar.vue'),
'components/NavbarShortcuts': () => import('/var/www/sites/stage.app.navodayatransport.com/releases/94/src/layouts/components/NavbarShortcuts.vue'),
'components/UserProfile': () => import('/var/www/sites/stage.app.navodayatransport.com/releases/94/src/layouts/components/UserProfile.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
